import {
  PriceData,
  Product,
  StyleColor,
} from '../../../../collaborators/fetch-products/new-contract/types';

const mapPriceType = (priceType: string) => {
  const DEFAULT_PRICE_TYPE = 1;
  const priceTypeMap: { [length: string]: number } = {
    R: 1,
    M: 2,
    P: 3,
  };

  return priceTypeMap[priceType] || DEFAULT_PRICE_TYPE;
};

const getPriceObject = (colors: StyleColor[]): PriceData =>
  colors &&
  colors.reduce(
    (
      {
        currentMinPrice,
        currentMaxPrice,
        regularMinPrice,
        regularMaxPrice,
        minPercentageOff,
        maxPercentageOff,
      },
      color
    ) => ({
      currentMinPrice: Math.min(currentMinPrice, +color.effectivePrice),
      currentMaxPrice: Math.max(currentMaxPrice, +color.effectivePrice),
      regularMinPrice: Math.min(regularMinPrice, +color.regularPrice),
      regularMaxPrice: Math.max(regularMaxPrice, +color.regularPrice),
      minPercentageOff: Math.min(minPercentageOff, +color.percentageOff),
      maxPercentageOff: Math.max(maxPercentageOff, +color.percentageOff),
      priceType: mapPriceType(color.priceType),
    }),
    {
      currentMinPrice: Number.POSITIVE_INFINITY,
      currentMaxPrice: Number.NEGATIVE_INFINITY,
      regularMinPrice: Number.POSITIVE_INFINITY,
      regularMaxPrice: Number.NEGATIVE_INFINITY,
      minPercentageOff: Number.POSITIVE_INFINITY,
      maxPercentageOff: Number.NEGATIVE_INFINITY,
    }
  );

export default (product: Product): PriceData => {
  return {
    ...getPriceObject(product.styleColors),
    // As validated the component only uses the currency notation and do the "localization" inside the product.
    localizedRegularMaxPrice: '$',
  };
};
